import {
  NgModule
} from '@angular/core';
import {
  CommonModule
} from '@angular/common';

import {
  DashboardComponent
} from './dashboard.component';
import { MatCardModule } from '@angular/material/card';
import { MatTabsModule } from '@angular/material/tabs';
import {ChartsModule} from '@progress/kendo-angular-charts';
import {DateInputsModule} from '@progress/kendo-angular-dateinputs';
import {DropDownsModule} from '@progress/kendo-angular-dropdowns';
import {SharedCommonModule} from '../shared/common';
import {LoadingIndicatorModule} from '../shared/layout/components/loading-indicator/loading-indicator.module';
import {AgmCoreModule} from '@agm/core';
import {FlexLayoutModule} from '@angular/flex-layout';
import {AgmJsMarkerClustererModule} from '@agm/js-marker-clusterer';
import {MatExpansionModule} from '@angular/material/expansion';

@NgModule({
  declarations: [
    DashboardComponent
  ],
  imports: [
    CommonModule,
    MatTabsModule,
    MatCardModule,
    ChartsModule,
    DateInputsModule,
    DropDownsModule,
    SharedCommonModule,
    LoadingIndicatorModule,
    MatExpansionModule,
    AgmCoreModule,
    AgmJsMarkerClustererModule,
    FlexLayoutModule
  ]
})
export class DashboardModule {
}
